import { type ClassValue, clsx } from "clsx";
import DOMPurify from "dompurify";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/** Oddiy matnda uchraydigan HTML obyektlari — Quill `&`, `<`, `>` ni shunday yozadi. */
const HTML_ENTITIES: Record<string, string> = {
  "&nbsp;": " ",
  "&amp;": "&",
  "&lt;": "<",
  "&gt;": ">",
  "&quot;": '"',
  "&#39;": "'",
  "&apos;": "'",
};

/**
 * Boy matndan HTML teglarni tozalaydi — oddiy matn sifatida ko'rsatish uchun.
 *
 * Blok teglar (`</p>`, `<br>`, `</li>`) BO'SHLIQQA aylanadi: ikki paragraf
 * "birinchi.Ikkinchi" bo'lib yopishib qolmasin. Qisqa tavsif ham boy matn
 * muharririda yoziladi, ya'ni `<p>…</p>` bilan keladi — ilgari moderatsiya
 * sahifasining sarlavhasida teglar xom holda ko'rinardi.
 */
export function stripHtml(html?: string | null): string {
  return (html ?? "")
    .replace(/<\/(p|div|li|h[1-6]|blockquote)>|<br\s*\/?>/gi, " ")
    .replace(/<[^>]*>/g, "")
    .replace(/&(nbsp|amp|lt|gt|quot|#39|apos);/g, entity => HTML_ENTITIES[entity] ?? entity)
    .replace(/\s+/g, " ")
    .trim();
}

/**
 * Boy matnni brauzerga qo'yishdan oldin tozalaydi.
 *
 * Kontentni Quill'da o'qituvchilar YOZADI, lekin o'qituvchilikka ariza
 * beruvchilar ham (`request.bio`) — ya'ni ro'yxatdan o'tgan istalgan odam
 * moderator ochadigan sahifaga HTML jo'nata oladi. `dangerouslySetInnerHTML`
 * bunday matnni to'g'ridan-to'g'ri bajaradi, shuning uchun HAR BIR sink shu
 * funksiya orqali o'tadi.
 *
 * Backend ham yozishda tozalaydi; bu ikkinchi qatlam ataylab qoldirilgan —
 * bazada allaqachon yotgan eski yozuvlar hech qachon qayta tozalanmaydi.
 */
/**
 * Kontentda forma elementlari kerak emas: DOMPurify standart holatda
 * `<form action="https://...">` va `<input>` ni qoldiradi — dars matni
 * ichida tashqi saytga ma'lumot yuboradigan forma bo'lishi mumkin edi.
 */
const FORBIDDEN_TAGS = ["form", "input", "button", "select", "option", "textarea", "label"];

export const sanitizeHtml = (html?: string | null) =>
  DOMPurify.sanitize(html ?? "", {
    USE_PROFILES: { html: true },
    FORBID_TAGS: FORBIDDEN_TAGS,
    FORBID_ATTR: ["formaction", "action"],
  });
